import { formatPercentage } from 'toolbox/format'
import greenMove from 'assets/logos/movement-move-green.svg'

export interface RewardRateProps {
  rewardRate: number
  timeFrame: string
  baseRate: number
  isBorrow?: boolean
}

export function RewardRate({ rewardRate, baseRate, isBorrow }: RewardRateProps) {
  return (
    <div className="reward-rate-display">
      <p className="plus">{formatPercentage(baseRate)}</p>
      <div className="pill">
        {isBorrow ? '-' : '+'}
        <p>{formatPercentage(rewardRate)}</p>
        <img src={greenMove} alt="MOVE" />
      </div>
      {/* <div className="time-frame-box">
        <div className="clock-icon" />
        <p>{timeFrame}</p>
      </div> */}
    </div>
  )
}
